module.exports = __webpack_public_path__ + "media/images/badges/cyclebar/red/RideClub_Milestones_App_2000-Red-1d8fc6e88e856166eda3fb60ce2914db.png";